module.exports = __webpack_public_path__ + "static/media/MonsterTruckBkgSplash.fab05b0c.png";